export default "__VITE_ASSET__Dz6ocV3v__"